import { useLocation } from 'react-router-dom'
import { getClientCompanyDetails } from '../../../../Services/SoleTrader'
import { connect, useDispatch } from 'react-redux'
import React, { useEffect, useState } from 'react'
import { Spin, Tabs } from 'antd'
import type { TabsProps } from 'antd'
import ServiceMain from './Buttons/ServicesTab/ServicesMain'
import HomeList from './Buttons/Home/HomeList'
import ContactInfoEditForm from './Buttons/ContactInfo/ContactInfoEditForm'
import Compliance from './Buttons/Compliance/compliance'
import SupplierInfo from './Buttons/SupplierInfo'
import Documentmain from './Buttons/Doucument/documentMain'
import SoleTraderConfiguration from './Buttons/soleTraderConfiguration'
import { type CorporateStateInterface } from '../../../../Types/Client/RegisteredClients/Corporate'

const SoleTraderTabs = (props: CorporateStateInterface): React.ReactElement => {
    const { isLoading } = props
    const location = useLocation()
    const { SoleTraderData, onbordingId } = location.state ?? {}
    const dispatch = useDispatch()
    const businessTypeId = 2
    const solderTapId = localStorage.getItem('solderTapId')
    const [activeTab, setActiveTab] = useState(solderTapId ?? '1')
    const soleTraderId = SoleTraderData?.soleTraderId
    const onChange = (key: string): void => {
        localStorage.setItem('solderTapId', key)
        setActiveTab(key)
    }

    useEffect(() => {
        if (soleTraderId !== null) {
            void getClientCompanyDetails(
                dispatch,
                businessTypeId,
                soleTraderId,
                parseInt(activeTab, 10)
            )
        }
    }, [activeTab, soleTraderId])

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: 'Home',
            children: <HomeList soleTraderId={soleTraderId} />,
        },
        {
            key: '4',
            label: 'Services',
            children: (
                <ServiceMain
                    soletrderId={SoleTraderData?.soleTraderId}
                    activeTab={activeTab}
                />
            ),
        },
        {
            key: '7',
            label: 'Supplier Info',
            children: (
                <SupplierInfo soleTraderId={SoleTraderData?.soleTraderId} />
            ),
        },
        {
            key: '5',
            label: 'Contact Info',
            children: <ContactInfoEditForm />,
        },
        {
            key: '3',
            label: 'Documents',
            children: <Documentmain soleTraderId={soleTraderId} />,
        },
        {
            key: '6',
            label: 'Compliance',
            children: (
                <Compliance
                    soleTraderId={soleTraderId}
                    onbordingId={onbordingId}
                />
            ),
        },
        {
            key: '8',
            label: 'Configuration',
            children: (
                <SoleTraderConfiguration
                    registeredClientSoleTraderConfiguration={''}
                />
            ),
        },
    ]

    return (
        <div style={{ width: '100%' }}>
            <Spin size="large" spinning={isLoading}>
                <Tabs activeKey={activeTab} onChange={onChange} items={items} />
            </Spin>
        </div>
    )
}

const mapStateToProps = (state: any): CorporateStateInterface => {
    return {
        isLoading: state.common.isLoading,
    }
}

export default connect(mapStateToProps)(SoleTraderTabs)
